module.exports = __webpack_public_path__ + "img/shine.ca68c9b3.png";